import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import profileImg from '../../../assets/images/profileImg.jpg';
import { connect } from 'react-redux';
import { requestReviewsContent } from '../../../store/actions/index';
import { injectIntl } from 'react-intl';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './Reviews.scss';

class Reviews extends React.Component {
    componentDidMount = () => {
        this.props.requestReviewsContent();
    }


    renderReviewsList = (reviews) => {
        if(reviews){
            return reviews.map(review => {
                return(
                    <div className="item p-4" key={review.id}>
                        <div className="container">
                            <div className="row py-5">
                                <div className="col-md-4">
                                <div className="profile_background">
                                <div className="reviews_profile_img" style={{backgroundImage:`url(${profileImg})`}}></div>
    
                                </div>
                                        <div className="review_writer_info">
                                            <p className="review_writer_name">{review.customer_name}</p>
                                            <p className="review_writer_position">{review.customer_job}</p>
                                        </div>
                                </div>
                                <div className=" col-md-8 review_col">
                <p className="review_content">{review.review}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )    
            })
        }
        else {
            return ;
        }
    }

    render(){
        const { lang , homeContent} = this.props ;
        const  { messages }  = this.props.intl;
        return(
            <React.Fragment>
                {homeContent.reviews.reviews && homeContent.reviews.reviews.length > 0 &&
                <div className="reviews_container d-flex align-items-center">
                    <div className="reviews_slider_container p-5">
                       <div className="text-center">
                        {lang === 'ar' && 
                            <h2 className="reviews_header pt-5 pb-2 bold_font">{homeContent.reviews.reviews_title_ar}</h2>
                        }
                        {lang === 'en' && 
                            <h2 className="reviews_header pt-5 pb-2 bold_font">{homeContent.reviews.reviews_title_en}</h2>
                        }
    <h3 className="reviews_sub_header bold_font">{messages.reviews_sub_header}</h3>
                       </div>
                       {  homeContent.reviews.reviews && homeContent.reviews.reviews.length > 0 && 
                        <OwlCarousel
                            ref="reviews"
                            className="owl-theme"
                            nav
                            navText = {['<' , '>']}
                            items = {1}
                            mouseDrag ={false}
                            loop
                            autoplay
                        >

                      {this.renderReviewsList(homeContent.reviews.reviews)}

                    </OwlCarousel> 
                 } 
                </div>
               
                </div>
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        homeContent : state.website.homeContent , 
        lang : state.locale.lang
    }
}
const ReviewsComponent = injectIntl(Reviews);

export default connect(mapStateToProps,{requestReviewsContent})(ReviewsComponent) ;